import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { ChangeProviderButton } from 'calling-integration-sdk-support/viewport/components/ChangeProviderButton';
import openCallingWidget from 'calling-global-api/methods/openCallingWidget';
import { logError } from 'calling-error-reporting/report/error';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ChangeProviderButtonWrapper = ({
  providerName,
  location
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "space-between",
    paddingInlineStart: "100",
    paddingInlineEnd: "400",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(ChangeProviderButton, {
      toggleProviderMenu: showProviderMenu => {
        openCallingWidget({
          showProviderMenu
        }).catch(error => {
          logError(error);
        });
      },
      size: "medium",
      location: location,
      providerName: providerName
    }), /*#__PURE__*/_jsx(Badge, {
      use: "new",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "callSettingsWidget.changeProviderNewBadge"
      })
    })]
  });
};
export default ChangeProviderButtonWrapper;